export default __webpack_public_path__ + "static/media/discord.dd0f736c.svg";